import React from 'react';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";
import axios from "axios";
import {config} from "../../../app/config";
import {LabeledInput} from "../../icymat-design/LabeledInput";
import {Button} from "../../icymat-design/Button";


class NewCalendarDialogClass extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            nameValue: '',
            urlValue: '',
            urlClass: 'main',
            color: 'blue',
            remainders: false
        }
    }

    renderColors = () => {
        let colors = ['red', 'magenta', 'violet', 'blue', 'cyan', 'teal', 'green', 'lime', 'yellow', 'amber', 'orange', 'brown'];
        let rows = [];

        let that = this;
        colors.forEach(function(color, key) {
            rows.push(<div
                key={key}
                className={'calendar-color selector imd-border-color-accent imd-bg-' + color + (color === that.state.color ? ' active' : '')}
                onClick={() => that.setState({color: color})}
            />);
        });

        return rows;
    }

    save = () => {
        let errors = 0;
        if (this.state.nameValue === '') {
            this.setState({nameClass: 'red'});
            errors++;
        } else {
            this.setState({nameClass: 'main'});
        }

        if (this.state.urlValue === '') {
            this.setState({urlClass: 'red'});
            errors++;
        } else {
            this.setState({urlClass: 'main'});
        }

        if (errors) {
            return;
        }

        let that = this;
        axios.post(config.apiAddress + '/app/calendar/calendars', {name: this.state.nameValue, url: this.state.urlValue, color: this.state.color, remainders: this.state.remainders})
            .then(function (response) {
                that.setState({
                    nameValue: '',
                    urlValue: '',
                    newColor: 'blue',
                    remainders: false
                });
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'calendars.subscribed_calendars.added'));
                that.props.close();
                that.props.callbackSuccess();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'calendars.data_loading_error'));
                that.props.preloaderHide();
            });
    }

    /**
     * @returns {JSX.Element}
     */
    render() {
        return (
            <dialog className={'imd-dialog imd-bg-blur-black' + (this.props.opened ? ' imd-opened' : '')}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header>
                        {TranslationService.trans(this.props.language, 'calendars.subscribed_calendars.add_new')}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => this.props.close()} />
                    </header>

                    <div className="imd-dialog-content">
                        <LabeledInput
                            label={TranslationService.trans(this.props.language, 'common.name')}
                            value={this.state.nameValue}
                            onChange={e => {this.setState({nameValue: e.target.value});}}
                        />

                        <LabeledInput
                            label={TranslationService.trans(this.props.language, 'common.url')}
                            value={this.state.urlValue}
                            onChange={e => {this.setState({urlValue: e.target.value});}}
                        />

                        {this.renderColors()}
                    </div>

                    <footer>
                        <Button
                            color={'accent'}
                            secondary={true}
                            text={TranslationService.trans(this.props.language, 'common.close')}
                            onClick={() => this.props.close()}
                        />
                        <Button
                            color={'main'}
                            text={TranslationService.trans(this.props.language, 'common.add')}
                            onClick={() => this.save()}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const NewCalendarDialog = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(NewCalendarDialogClass);
